import { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";
import AuthProvider from "../providers/AuthProvider";
import ReduxToastContainer from "../components/ui/toast/ReduxToastContainer";
import Loader from "../components/ui/loader/Loader";
import { registerServiceWorker } from "../lib/utils/notification-worker";

/**
 * RootLayout - Wraps all routes with AuthProvider and ToastContainer
 * This ensures AuthProvider has access to Router context (useNavigate)
 */
export default function RootLayout() {
  // Initialize service worker on app load
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      registerServiceWorker().catch((error) => {
        console.error("[RootLayout] Service worker registration failed:", error);
      });
    }
  }, []);

  return (
    <AuthProvider>
      <Suspense fallback={<Loader />}>
        <Outlet />
        <ReduxToastContainer />
      </Suspense>
    </AuthProvider>
  );
}
